<template>
  <div class="pageIntro">
    <h2>Hello World!</h2>
    <div class="row">
      <h3>my name is:</h3>
      <span class="name">Jen</span>
    </div>
  </div>
  <!-- create an on hover display to say: -->
  <!-- Prefers: Jen -->
  <div class="about">
    <div class="aboutBio">
      <div class="part" v-for="(item, index) in biographies" :key="index">
        <div class="photoBox">
          <!-- <polaroid-pic :imgFile="item.photo" class="portrait" /> -->
          <polaroid-pic :imgFile="item.photo" :class="{ 'portrait': index === 1 }" :alt="item.alt" />
        </div>
        <div class="bio">
          <p>{{ item.paragraph }}</p>
          <div class="summary">
            <span style="font-weight: bold; margin-bottom: 10px;">TLDR:</span>
            <span v-for="(line, idx) in item.summary" :key="idx">{{ line }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>


</template>
<script>
export default {
  data() {
    return {
      biographies: [
        {
          photo: 'about.jpg',
          alt: "RMNP along Old Fall River Road, CO. Mt. Julian, Mt. Ida, and Sprague Mountain in the background. A photo taken from behind a person on a mountain ridge, looking out over a valley of pine trees and other mountains. The person has brown hair tied in a loose braid and is wearing a plaid shirt and floral shorts. They are holding what appears to be a camera strap, and a strong wind is visibly blowing their hair and shirt.",
          paragraph: "A web developer who thrives on logic and creativity. I love solving complex problems through crafting thoughtful, user- friendly designs. With  a background in both art and tech, I’m seeking full - time work where I can create polished, engaging web experiences that balance beauty and function.",
          summary: ["Design is art applied to function;", "Development is a puzzle;", "Jen loves both."],
        }, {
          photo: 'family2.jpg',
          alt: "Taken in Indianapolis, IN. Jennifer is lounged in a hammock cuddled up with her husband, a pastime they both love. A man and woman are smiling and cuddling together in a hammock outdoors on a sunny day. The man is sitting up and has a protective arm around the woman, who is lying with her head on his lap. He is wearing a blue patterned shirt, and she is wearing a white tank top with a light blue print. A bicycle and green grass are in the blurred background.",
          paragraph: "In past roles, I often found myself craving more creative opportunity. Web development has proven to be the perfect blend of problem-solving and artistry. Bringing a design to life allows me to apply precision and care to every detail, elevating the quality and impact of the final product.",
          summary: ["Previous work wasn't creative;", "Development is both art and puzzle;", "Jen loves development."],
        }, {
          photo: 'paintingSQ.jpg',
          alt: "Taken in Holiday Island, AR. Jennifer gives an impromptu painting lesson to her many nieces. Photo credit to Isabella for taking this photo to remember this moment.A candid, close-up photo of a woman with glasses and a green jacket, smiling as she holds a small paintbrush to a watercolor painting on a gray patterned tablecloth. Several small watercolor art pieces are laid out, along with a palette, brushes, and a spray bottle.",
          paragraph: "Web developer by day, artist by night, I’m a coffee-loving transplant originally from Seattle, now living in the Midwest. My husband, dog, and two cats keep life interesting in Fountain Square. When the weather’s nice, you’ll find us outside enjoying it to the fullest.",
          summary: ["A Midwest transplant from Seattle;", "A web developer by day, artist by night;", "Jen loves coffee, her family, and the outdoors;"],
        }
      ]
    };
  },
};
</script>
<style scoped>
/* About Styles */
.about {
  /* Style */
  background-color: rgba(240, 255, 255, 0.3);
  box-shadow: 0 0 16px 0 rgba(85, 38, 38, 0.4);
  border-radius: 15px;
  /* spacing and alignment */
  padding: 30px 45px;
}

.about .aboutBio {
  width: 100%;
}

.about .aboutBio .part {
  width: 100%;
  /* spacing */
  margin-bottom: 20px;
  display: flex;
}

.about .aboutBio .part .photoBox {
  /* size */
  width: 75%;

  /* alignmnet */
  display: flex;
  align-items: center;
  justify-content: center;
}

.about .aboutBio .part .bio {
  width: 100%;
  padding-left: 3%;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.about .aboutBio .part .bio p {
  font-size: 16px;
  line-height: 25px;
  margin: 0 auto;
}

.about .aboutBio .part .bio .summary {
  background-color: rgba(255, 255, 255, 0.35);
  padding: 15px;
  border-radius: 15px;
  margin-top: 25px;

  display: none;
  flex-direction: column;
}

.about .aboutBio .part .bio .summary span {
  align-self: flex-start;
  font-size: 18px;
  font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif;
}

.about .aboutBio .part:hover .bio {
  /* spacing */
  justify-content: space-evenly;
}

.about .aboutBio .part:hover .bio .summary {
  display: flex;
}

.about .portrait {
  width: 70%;
}

/* small desktop */
@media only screen and (max-width: 1350px) {
  .about .aboutBio .part .photoBox {
    width: 40%;
    margin-right: 30px;
  }

  .about .aboutBio .part .bio {
    width: 60%;
  }
}

/* Tablet */
@media only screen and (max-width: 915px) {
  .about .aboutBio .part {
    flex-direction: column;
    align-items: center;
  }

  .about .aboutBio .part .photoBox {
    width: 100%;
    margin: 0;
    margin-bottom: 15px;
  }

  .about .aboutBio .part .bio {
    width: 100%;
  }

  .about .aboutBio .part .bio .summary {
    margin-bottom: 45px;
  }
}

/* Mobile */
@media only screen and (max-width: 560px) {
  .about {
    padding: 15px 0px;
  }

  .about .aboutBio .part .photoBox {
    width: 80%;
  }

  .about .aboutBio .part .bio {
    width: 100%;
    padding: 20px 20px 10px;
  }
}

/* END About Styles */
</style>
